import { useDistractionFreeMode } from 'module/hooks/use-distraction-free-mode';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import contains from 'document.contains';
import { FC, useEffect, useRef, useState } from 'react';
import * as React from 'react';
import { Sidebar } from './sidebar';

interface ClassNameOnlyProps {
  className?: string;
}
export const Peel: FC<React.PropsWithChildren<ClassNameOnlyProps>> = ({
  children,
  className,
}) => {
  const [hovered, toggleHovered] = useState(false);
  const { active, enter, exit } = useDistractionFreeMode();
  const [collapsed, toggleCollapsed] = useState(active);
  const triggerRef = useRef(null);

  useEffect(() => {
    toggleCollapsed(!(!active || hovered));
  }, [hovered, active]);

  const onMouseMove = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (contains(triggerRef.current, e.target)) {
      e.stopPropagation();
      e.preventDefault();

      return;
    }

    if (active && !hovered) {
      toggleHovered(true);
    }
  };

  const onMouseLeave = () => {
    if (active && hovered) {
      toggleHovered(false);
    }
  };

  const onCollapse = () => {
    if (active) {
      exit();
    } else {
      enter();
    }

    toggleHovered(active);
  };

  return (
    <Sidebar
      theme="light"
      className={className}
      $pinned={!active}
      collapsed={collapsed}
      trigger={
        <div ref={triggerRef}>
          {!active ? (
            <FontAwesomeIcon icon={faChevronLeft} size="sm" />
          ) : (
            <FontAwesomeIcon icon={faChevronRight} size="sm" />
          )}
        </div>
      }
      onCollapse={onCollapse}
      onMouseMove={onMouseMove}
      onMouseLeave={onMouseLeave}
    >
      {children}
    </Sidebar>
  );
};
